var map = {
	"./79_pizza.mp3": "7479",
	"./80_cheese.mp3": "33e2",
	"./81_tomato sauce.mp3": "f704",
	"./82_ham.mp3": "2381",
	"./M_Brilliant.mp3": "b812",
	"./M_Excellent.mp3": "ff54",
	"./M_Fantastic.mp3": "c15c",
	"./M_Great.mp3": "da33",
	"./M_Perfect.mp3": "ad56",
	"./M_Think again.mp3": "6630",
	"./M_Try again.mp3": "08e2",
	"./M_Very good.mp3": "b349",
	"./M_Well done.mp3": "4dc7",
	"./M_Work harder.mp3": "646d",
	"./click.mp3": "2f00",
	"./false.mp3": "9776"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbd7";